import { QueryClient } from '@tanstack/react-query';

export async function invalidateIntegrationRequestsCacheQueries(queryClient: QueryClient) {
  try {
    await Promise.all([
      queryClient.removeQueries({ queryKey: ['integrationRequests'], type: 'inactive' }),
      queryClient.invalidateQueries({ queryKey: ['integrationRequests'], type: 'active' }),
    ]);
  } catch (error) {
    console.error('Failed to invalidate integration requests cache queries:', error);
  }
}
